import { Box } from "@mui/system";

export default function LogATicket() {
	return (
		<Box mt={{ sm: 2, xs: 1 }} display={"flex"} width={"100%"} overflow={"auto"} pb={2}>
			<Box maxWidth={"1280px"} minWidth={"720px"} maxHeight={"720px"} minHeight={"405px"} width={"80%"} m={"auto"}>
				<Box position={"relative"} pb={"56.25%"}>
					<iframe
						title={"Log A Ticket"}
						width={"100%"}
						height={"100%"}
						src={
							"https://apps.powerapps.com/play/e/default-e4d98dd2-9199-42e5-ba8b-da3e763ede2e/a/d5edeff3-e4d1-4687-9f2c-2e34358e39cc?tenantId=e4d98dd2-9199-42e5-ba8b-da3e763ede2e"
						}
						style={{
							border: "none",
							top: 0,
							left: 0,
							position: "absolute",
						}}
					/>
				</Box>
			</Box>
		</Box>
	);
}
